<template>
    <!-- "?" da página: abre o artigo (primary) da rota atual. Rota sem artigo publicado = sem botão. -->
    <AjudaBotao v-if="slug" :slug="slug" :variante="variante" titulo="Ajuda desta tela" />
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import AjudaBotao from '@/components/AjudaBotao.vue';
import { AJUDA_POR_ABA, ajudaDaRota, defineAjudaAba } from '@/config/ajudaEngage';

defineProps({
    // 'nav' no cabeçalho do sistema; 'flutuante' nas telas sem cabeçalho
    variante: { type: String, default: 'nav' },
});

const route = useRoute();
const store = useStore();

// Troca de tela volta ao artigo geral; flush sync para rodar antes da nova tela informar a sua aba
watch(() => route.path, (path) => defineAjudaAba(path, null), { flush: 'sync', immediate: true });

// Abas Bootstrap (data-bs-toggle="tab"): o id do link da aba escolhe o artigo
// (abas de outros componentes, como as de um popup, não estão no mapa e são ignoradas)
const aoMostrarAba = (ev) => {
    const id = ev.target && ev.target.id;
    if (id && (AJUDA_POR_ABA[route.path] || {})[id]) defineAjudaAba(route.path, id);
};
onMounted(() => document.addEventListener('shown.bs.tab', aoMostrarAba));
onBeforeUnmount(() => document.removeEventListener('shown.bs.tab', aoMostrarAba));

// Buscar e Favoritos compartilham a rota /apps/busca: o modo vem do Vuex
const slug = computed(() => ajudaDaRota(route.path, { buscaFavorito: store.getters.buscaFavorito }));
</script>
